import { render } from "./ItemReceive_add.vue?vue&type=template&id=2918148a"
import script from "./ItemReceive_add.vue?vue&type=script&lang=js"
export * from "./ItemReceive_add.vue?vue&type=script&lang=js"

import "./ItemReceive_add.vue?vue&type=style&index=0&id=2918148a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__